import React from 'react';

export type Severity = 'critical' | 'high' | 'medium' | 'low' | 'info';

interface SeverityBadgeProps {
  severity: Severity;
  size?: 'sm' | 'md';
  showDot?: boolean;
}

const config: Record<Severity, { label: string; classes: string; dot: string }> = {
  critical: {
    label: 'Critical',
    classes: 'bg-red-500/15 text-red-400 border border-red-500/25',
    dot: 'bg-red-500',
  },
  high: {
    label: 'High',
    classes: 'bg-orange-500/15 text-orange-400 border border-orange-500/25',
    dot: 'bg-orange-500',
  },
  medium: {
    label: 'Medium',
    classes: 'bg-amber-500/15 text-amber-400 border border-amber-500/25',
    dot: 'bg-amber-500',
  },
  low: {
    label: 'Low',
    classes: 'bg-blue-500/15 text-blue-400 border border-blue-500/25',
    dot: 'bg-blue-500',
  },
  info: {
    label: 'Info',
    classes: 'bg-zinc-700/50 text-zinc-400 border border-zinc-700',
    dot: 'bg-zinc-500',
  },
};

export default function SeverityBadge({ severity, size = 'sm', showDot = true }: SeverityBadgeProps) {
  const { label, classes, dot } = config[severity];
  const sizeClasses = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-1';

  return (
    <span className={`inline-flex items-center gap-1 rounded font-semibold uppercase tracking-wide ${classes} ${sizeClasses}`}>
      {showDot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dot}`} />}
      {label}
    </span>
  );
}